import { TipAdjustmentSaleFields } from "../interfaces/sales";

/**
 * A tip-adjustment sale is the one created to reassign a seller's tip to their primary
 * concession. The API exposes this via the sale's `type` field ("tip_adjustment"), so the
 * classification is authoritative instead of inferred from subtotal/products.
 * @param sale Sale with its `type` field
 * @returns true when the sale is a tip-adjustment sale
 */
export const isTipAdjustmentSale = (sale: TipAdjustmentSaleFields): boolean => {
  return sale.type === "tip_adjustment";
};
